import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-136">
      {/* Background Glow — desktop only */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-primary/15 rounded-full blur-[80px] pointer-events-none hidden sm:block" data-id="element-137"></div>

      {/* Attention Badge */}
      <div className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2" data-id="element-138">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red animate-pulse" data-id="element-139"></span>
        <span className="hidden sm:inline" data-id="element-140">
          🏉 ATENCIÓN: ENTRENADORES Y PROFESORES DE RUGBY CANSADOS DE IMPROVISAR
          CADA ENTRENAMIENTO
        </span>
        <span className="sm:hidden" data-id="element-141">ATENCIÓN: ENTRENADORES DE RUGBY</span>
      </div>

      {/* Main headline */}
      <h1 className="relative font-black text-text-main max-w-5xl text-[26px] leading-[1.15] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight" data-id="element-142">
        Deja de ser un esclavo de la planificación y{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400" data-id="element-143">
          recupera tus tardes.
        </span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-text-sec text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/5 sm:border sm:border-white/10 sm:border-l-4 sm:border-l-primary sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left" data-id="element-144">
        El único Sistema 360{' '}
        <span className="text-primary font-bold" data-id="element-145">"Llegar y Entrenar"</span> que
        resuelve tu temporada completa de Rugby en 5 minutos.{' '}
        <span className="hidden sm:inline text-text-main font-semibold" data-id="element-146">
          Sin dudas, sin desorden y sin sesiones vacías.
        </span>
      </p>

      {/* Mockup image — LCP element, no animations, no filters on mobile */}
      <div className="relative w-full max-w-[240px] sm:max-w-[380px] md:max-w-[460px] mx-auto mb-4 sm:mb-8" data-id="element-147">
        <div className="absolute inset-0 bg-primary/15 blur-[40px] rounded-full hidden sm:block" data-id="element-148"></div>
        <img src="https://cdn.magicpatterns.com/uploads/ioLFTKmWo7az1MfForKjze/Diseno-sin-titulo-_33_.webp" alt="EDULABS MegaPack Rugby Listo — Sistema Integral 360" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" width={500} height={500} fetchPriority="high" data-id="element-149" />
      </div>

      {/* Stars + Urgency */}
      <div className="relative flex flex-col items-center gap-2 mb-4 sm:mb-6" data-id="element-150">
        <div className="flex items-center gap-2" data-id="element-151">
          <span className="text-secondary text-sm sm:text-lg" data-id="element-152">⭐⭐⭐⭐⭐</span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-153">
            4.9/5 (+500 Verificados)
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-3 py-1 rounded-full border border-secondary/20" data-id="element-154">
          🔥 38 entrenadores compraron hoy
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white border border-white/10" data-id="element-155">
        🚀 ¡SÍ! DAME MI TIEMPO DE VUELTA
      </a>

      {/* Trust badges */}
      <p className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-156">
        <span data-id="element-157">⚡ Acceso Inmediato</span>
        <span data-id="element-158">•</span>
        <span data-id="element-159">🛡️ Garantía 7 Días</span>
        <span data-id="element-160">•</span>
        <span data-id="element-161">💳 Pago Único</span>
      </p>
    </section>;
}